












































































import {
  Advisor,
  BaseView,
  Component,
  ComponentStyle,
  ComponentStyleDefinition,
  InjectComponent,
  Prop,
  SectionType,
  VueComponent,
} from "@zoovu/runner-browser-api";
import { AdvisorSectionView } from "@zoovu/runner-web-design-base";

@Component({
  name: "AdvisorSectionView",
  mixins: [AdvisorSectionView],
})
export default class AdvisorSectionViewExtended extends BaseView {
  @InjectComponent("PagesNavigationView")
  pagesNavigationView: VueComponent;

  @InjectComponent("StartOverButtonView")
  startOverButtonView: VueComponent;

  @InjectComponent("PageSelectorView")
  pageSelectorView: VueComponent;

  @ComponentStyle()
  componentStyle: ComponentStyleDefinition;

  @Prop()
  advisor: Advisor;

  @Prop()
  sectionType: SectionType;

  @Prop({ default: false })
  startOverButtonWithHeader: boolean;

  @Prop({ default: true })
  showNavigationAboveMainSection: boolean;

  @Prop({ default: true })
  showNavigationBelowMainSection: boolean;

  @Prop({ default: true })
  showPageSelectorBetweenNavigationButtons: boolean;

  @Prop({ default: false })
  showPageSelectorAboveMainSection: boolean;

  @Prop()
  rootElementClass: string;

  toLeftSide = "toLeft";

  toCenter = "toCenter";

  get isEmptyQuestionaire(): boolean {
    return this.isQuestionnaire ? this.advisor.flowStepsNavigation.flowSteps.length === 0 : false;
  }
}
